exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Inner label for glass pill buttons (styles from menu-bar.css) */\n.connected-center-publish_glassBtnLabel_q--bQ {\n    font-size: 0.75rem;\n    font-weight: 500;\n    white-space: nowrap;\n    line-height: 1;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n.connected-center-publish_glassBtnDisabled_yDsaI {\n    opacity: 0.55;\n    cursor: wait;\n    pointer-events: none;\n}\n", ""]);

// exports
exports.locals = {
	"glassBtnLabel": "connected-center-publish_glassBtnLabel_q--bQ",
	"glassBtnDisabled": "connected-center-publish_glassBtnDisabled_yDsaI"
};